import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {Collapse} from 'react-collapse';
import './style';

class ProjectItem extends Component {
  static propTypes = {
    isOpened: PropTypes.bool
  };

  static defaultProps = {
    isOpened: false
  };

  constructor(props) {
    super(props);
    this.state = {isOpened: this.props.isOpened};
  }

  render() {
    const { theme: { colorPrimary, colorAlternate } } = this.context;
    const {isOpened} = this.state;

    return (
        <div
          className="project-item"
          style={{ backgroundColor: colorAlternate, color: colorPrimary }}
        >
          <div
            className={"project-item__title"}
            onClick={() => this.setState({isOpened: !isOpened})}>
            <div className="project-item__title__text">
              {this.props.title}
            </div>
            <div className="project-item__title__icon">
              <i className={(isOpened ? "fas fa-minus" : "fas fa-plus")}></i>
            </div>
          </div>

          <Collapse isOpened={isOpened}>
            <div className="project-item__desc">
              {this.props.desc}
            </div>
            <div className="project-item__links">
              {this.props.links.map((link, i) => (
                <a target="_blank" rel="noopener noreferrer" href={link.url} key={i}>{link.text}</a>
              ))}
            </div>
          </Collapse>
        </div>
    );
  }
};

ProjectItem.contextTypes = {
  theme: PropTypes.any
};

export default ProjectItem;



// WEBPACK FOOTER //
// ./src/components/ProjectItem/ProjectItem.js